var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCares = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 11.375C23.625 6.06775 19.3073 1.75 14 1.75C8.69275 1.75 4.375 6.06775 4.375 11.375C4.375 11.375 1.75 12.5525 1.75 14V15.75C1.75 17.1975 2.92749 18.375 4.375 18.375H5.25C5.73322 18.375 6.125 17.9832 6.125 17.5V11.375C6.125 7.0329 9.6579 3.5 14 3.5C18.3421 3.5 21.875 7.0329 21.875 11.375V17.5C21.875 17.9832 22.2668 18.375 22.75 18.375H23.625C25.0725 18.375 26.25 17.1975 26.25 15.75V14C26.25 12.5525 23.625 11.375 23.625 11.375Z",
    fill: "url(#paint0_linear_640_5316)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.625H10.5C9.05025 9.625 7.875 10.8003 7.875 12.25V15.75C7.875 17.1997 9.05025 18.375 10.5 18.375H13.125L15.8782 20.8718C15.9623 20.9564 16.0747 21 16.1875 21H16.1965C16.4404 21.0111 16.6425 20.8073 16.6425 20.5625C16.6425 20.4711 16.6143 20.386 16.5665 20.316L15.75 18.375H17.5C18.9497 18.375 20.125 17.1997 20.125 15.75V12.25C20.125 10.8003 18.9497 9.625 17.5 9.625Z",
    fill: "url(#paint1_linear_640_5316)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7317 19.25C22.3132 21.729 20.0963 23.625 17.5 23.625H16.3823C16.0791 23.1041 15.5211 22.75 14.875 22.75H13.125C12.1585 22.75 11.375 23.5335 11.375 24.5C11.375 25.4665 12.1585 26.25 13.125 26.25H14.875C15.5211 26.25 16.0791 25.8959 16.3823 25.375H17.5C21.0628 25.375 24.0672 22.6974 24.5 19.25H22.7317Z",
    fill: "url(#paint2_linear_640_5316)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_640_5316",
    x1: 1.75,
    y1: 8.81562,
    x2: 26.25,
    y2: 8.81562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_640_5316",
    x1: 7.875,
    y1: 14.4596,
    x2: 20.125,
    y2: 14.4596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_640_5316",
    x1: 11.375,
    y1: 22.225,
    x2: 24.5,
    y2: 22.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCares, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cares.1f8246c3.svg";
export { ForwardRef as ReactComponent };